import { createSlice } from '@reduxjs/toolkit'

export const ProjectCountDisplayStatus = createSlice({
  name: 'project_status_display',
  initialState: {
    value : []
  },
  reducers: {
    projectCountFilter: (state, action) => {
      state.value = action.payload
    },
  },
})

export const { projectCountFilter } = ProjectCountDisplayStatus.actions

export default ProjectCountDisplayStatus.reducer